import React, { useEffect, useMemo, useState } from 'react';
import serverRequest from '../../../utils/serverRequest';
import './Atena.css';
import TheHeader from "../../../containers/TheHeader";
import TheFooter from "../../../containers/TheFooter";




const palette = {
  headerGrad: 'linear-gradient(135deg, #0a0f2b 0%, #1b2357 45%, #4b2b8a 100%)',
  cardBg: '#0f1730',
  border: '#1c2a57',
  text: '#eaeefb',
  subText: '#b9c2f2',
  primary: '#6c5ce7',
};

const gruposCC = ['Mutant','GRB','Intervalor','Myra','Interaxa'];

function useParamsId() {
  const hash = typeof window !== 'undefined' ? window.location.hash : '';
  const parts = hash.split('/');
  const id = parseInt(parts[parts.length - 1], 10);
  return Number.isNaN(id) ? null : id;
}

export default function AtenaTratamentoChamado(){
  const id = useParamsId();

  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [anotando, setAnotando] = useState(false);

  const [categorias, setCategorias] = useState([]);
  const [ticket, setTicket] = useState(null);
  const [form, setForm] = useState({ categoria:'', titulo:'', prioridade:'Média', caminho:'', descricao:'' });

  const [status, setStatus] = useState('Aberto');
  const [grupo, setGrupo] = useState(''); // centro de custo em fechamento
  const [anotacoes, setAnotacoes] = useState([]);
  const [novaAnotacao, setNovaAnotacao] = useState('');

  const prioridades = useMemo(()=>['Baixa','Média','Alta','Crítica'], []);
  const statusOpts  = useMemo(()=>['Aberto','Em Atendimento', 'Aguardando Retorno','Resolvido','Cancelado'], []);

  async function loadAll(isMounted){ // isMounted adicionado como argumento
    setCarregando(true);
    try {
      // Requisições GET feitas em paralelo
      const [cat, tk, notes] = await Promise.all([
        serverRequest.get('/atena/categorias'),
        serverRequest.get(`/atena/chamados/obter?id_ticket=${id}`),
        serverRequest.get(`/atena/chamados/anotacoes?id_ticket=${id}`)
      ]);
      
      // 💡 CORREÇÃO: Só atualiza o estado se o componente ainda estiver montado (isMounted é true)
      if (isMounted) {
        setCategorias(Array.isArray(cat) ? cat : []);

        setTicket(tk || null);
        if (tk){
          setForm({
            categoria: tk.categoria,
            titulo: tk.titulo,
            prioridade: tk.prioridade,
            caminho: tk.caminho,
            descricao: tk.descricao
          });
          setStatus(tk.status);
          setGrupo(tk.grupo_responsavel || '');
        }
        setAnotacoes(Array.isArray(notes) ? notes : []);
      }
    } catch (e) {
      // Se a falha for 403, o alerta original já foi acionado na tela
      console.error('Falha ao carregar o chamado:', e);
      if (isMounted) {
          alert('Falha ao carregar o chamado.');
      }
    } finally {
      if (isMounted) {
        setCarregando(false);
      }
    }
  }

  // 💡 CORREÇÃO: Adicionando a função de limpeza (cleanup) no useEffect
  useEffect(()=>{ 
      let isMounted = true; 
      
      if (id) {
          // Passamos a flag para a função loadAll
          loadAll(isMounted); 
      }
      
      return () => {
          // A função de limpeza define a flag como false quando o componente desmonta
          isMounted = false;
      };
  }, [id]);

  const canSave = form.categoria && form.titulo.trim().length>=3 && form.caminho.trim().length>2 && form.descricao.trim().length>=10;

  async function salvarEdicao(){
    if (!canSave) return;
    setSalvando(true);
    try {
      await serverRequest.request('/atena/chamados/editar', {
        id_ticket: id,
        categoria: form.categoria,
        titulo: form.titulo,
        descricao: form.descricao,
        caminho: form.caminho,
        prioridade: form.prioridade
      });
      alert('Chamado atualizado.');
    } catch (e) {
      alert('Falha ao salvar.');
    } finally {
      setSalvando(false);
    }
  }

  async function salvarStatus(){
    // se fechando, exige centro de custo
    if ((status === 'Resolvido' || status === 'Cancelado') && !grupo) {
      alert('Selecione o Centro de Custo ao fechar o chamado.');
      return;
    }
    try {
      await serverRequest.request('/atena/chamados/atualizar-status', { id_ticket: id, status, grupo });
      alert('Status atualizado.');
    } catch (e) {
      alert('Falha ao atualizar status.');
    }
  }

  async function adicionarAnotacao(){
    if (!novaAnotacao.trim()) return;
    setAnotando(true);
    // Não precisamos de isMounted aqui, pois a requisição subsequente
    // de notas garante que o componente está montado
    try {
      await serverRequest.request('/atena/chamados/anotar', { id_ticket: id, anotacao: novaAnotacao.trim() });
      setNovaAnotacao('');
      
      // Recarrega as anotações
      const r = await serverRequest.get(`/atena/chamados/anotacoes?id_ticket=${id}`);
      setAnotacoes(Array.isArray(r) ? r : []);
      
    } catch (e) {
      alert('Falha ao adicionar anotação.');
    } finally {
      setAnotando(false);
    }
  }

  if (!id) return <div className="atena-page"><div className="empty">ID inválido.</div></div>;
  if (carregando) return <div className="atena-page"><div className="empty">Carregando…</div></div>;

  const mostrandoGrupo = status === 'Resolvido' || status === 'Cancelado';

  // O restante do JSX permanece o mesmo

return (
  <>
    <TheHeader />
   

    <div
      style={{
        backgroundImage: "url('../img/bg-gorila.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <div className="atena-page">

        <div
          className="tratamento-header"
          style={{
            background: palette.headerGrad,
            color: palette.text,
            borderRadius: 16,
            padding: 16,
            margin: '0 auto 16px',
            
          }}
        >
          <h3 style={{ margin: 0, fontWeight: 800 }}>
            Tratativa do Chamado #{id}
          </h3>
          <small style={{ color: palette.subText }}>
            Criado por: {ticket?.criado_por} • Criado em: {ticket?.criado_em}
          </small>
        </div>

        <div
          className="tratamento-grid"
          style={{
            display: 'grid',
            gap: 16,
            width: 1000,
            margin: '0 auto 40px',
          }}
        >
          {/* Form principal */}
          <div
            className="card"
            style={{
              background: palette.cardBg,
              color: palette.text,
              border: `1px solid ${palette.border}`,
              borderRadius: 16,
              padding: 16,
            }}
          >
            <h4 style={{ marginBottom: 12 }}>Dados do Chamado</h4>

            <div className="form-grid">
              <div className="input-group">
                <label>Categoria *</label>
                <select
                  value={form.categoria}
                  onChange={(e) =>
                    setForm({ ...form, categoria: e.target.value })
                  }
                >
                  <option value="">Selecione…</option>
                  {categorias.map((c) => (
                    <option key={c.id} value={c.nome}>
                      {c.nome}
                    </option>
                  ))}
                </select>
              </div>

              <div className="input-group">
                <label>Título *</label>
                <input
                  value={form.titulo}
                  onChange={(e) =>
                    setForm({ ...form, titulo: e.target.value })
                  }
                  maxLength={140}
                />
              </div>

              <div className="input-group">
                <label>Prioridade *</label>
                <select
                  value={form.prioridade}
                  onChange={(e) =>
                    setForm({ ...form, prioridade: e.target.value })
                  }
                >
                  {prioridades.map((p) => (
                    <option key={p}>{p}</option>
                  ))}
                </select>
              </div>

              <div className="input-group">
                <label>Caminho/Tela *</label>
                <input
                  value={form.caminho}
                  onChange={(e) =>
                    setForm({ ...form, caminho: e.target.value })
                  }
                />
              </div>

              <div className="input-group" style={{ gridColumn: '1 / -1' }}>
                <label>Descrição *</label>
                <textarea
                  rows={7}
                  value={form.descricao}
                  onChange={(e) =>
                    setForm({ ...form, descricao: e.target.value })
                  }
                />
                <div className="help">
                  {form.descricao.length}/10000
                </div>
              </div>
            </div>

            <div className="buttons-container" style={{ justifyContent: 'flex-start' }}>
              <button disabled={!canSave || salvando} onClick={salvarEdicao}>
                {salvando ? ' Salvando…' : ' Salvar alterações'}
              </button>
              <button className="ghost" onClick={() => window.history.back()}>
                Voltar
              </button>
            </div>
          </div>

          {/* Status + Notas */}
          <div
            className="card"
            style={{
              background: palette.cardBg,
              color: palette.text,
              border: `1px solid ${palette.border}`,
              borderRadius: 16,
              padding: 16,
            }}
          >
            <h4 style={{ marginBottom: 12 }}>Status & Notas</h4>

            <div className="input-group">
              <label>Status</label>
              <select value={status} onChange={(e) => setStatus(e.target.value)}>
                {statusOpts.map((s) => (
                  <option key={s}>{s}</option>
                ))}
              </select>
            </div>

            {mostrandoGrupo && (
              <div className="input-group">
                <label>Centro de Custo (grupo responsável)</label>
                <select value={grupo} onChange={(e) => setGrupo(e.target.value)}>
                  <option value="">Selecione…</option>
                  {gruposCC.map((g) => (
                    <option key={g} value={g}>
                      {g}
                    </option>
                  ))}
                </select>
                <div className="help">
                  Obrigatório ao fechar (Resolvido/Cancelado).
                </div>
              </div>
            )}

            <div className="buttons-container" style={{ justifyContent: 'flex-start', marginBottom: 10 }}>
              <button onClick={salvarStatus}>Atualizar Status</button>
            </div>

            <div className="input-group">
              <label>Adicionar anotação</label>
              <textarea
                rows={3}
                value={novaAnotacao}
                onChange={(e) => setNovaAnotacao(e.target.value)}
                placeholder="Descreva o que foi tratado, causa raiz, ação, evidências, etc."
              />
            </div>

            <div className="buttons-container" style={{ justifyContent: 'flex-start' }}>
              <button
                disabled={anotando || !novaAnotacao.trim()}
                onClick={adicionarAnotacao}
              >
                {anotando ? ' Adicionando…' : ' Adicionar'}
              </button>
            </div>

            <div className="notes">
              {anotacoes.length === 0 ? (
                <div className="empty">Sem anotações.</div>
              ) : (
                anotacoes.map((a) => (
                  <div key={a.id} className="note-item">
                    <div className="note-header">
                      <b>{a.criado_por}</b>
                      <span>{a.criado_em}</span>
                    </div>
                    <div className="note-body">{a.anotacao}</div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

    <TheFooter />
  </>
);

}